import { IconPay } from '@hyphengroup/cms-components/components/Icon';
import { AttrPaymentMethod } from '@hyphengroup/cms-components/types/attributes';
import {
  PaymentBadgeSource,
  resolvePaymentBadgeIcon,
} from '@hyphengroup/cms-components/utils/paymentBadgeIcon';

type PaymentIconBadge = {
  icon: IconPay | undefined;
  logo: AttrPaymentMethod['icon'] | undefined;
  key: string;
  label: string;
};

export const getPaymentIconBadges = (
  payments: PaymentBadgeSource[],
): PaymentIconBadge[] => {
  const seenPayments = new Set<string>();

  return payments.flatMap((payment) => {
    const label = payment.label.trim();
    const badgeIcon = resolvePaymentBadgeIcon(payment);
    const icon = badgeIcon?.type === 'legacy' ? badgeIcon.icon : undefined;
    const logo = badgeIcon?.type === 'logo' ? badgeIcon.logo : undefined;
    // Values sharing one visual (VISA, VISA Infinite, ...) collapse into a single badge.
    const key = logo?.url ?? icon?.toString() ?? label.toLowerCase();

    if (!label || seenPayments.has(key)) {
      return [];
    }

    seenPayments.add(key);

    return [{ icon, logo, key, label }];
  });
};
